module.exports = __webpack_public_path__ + "static/img/渠道-2.94faa17d.png";